// @flow

// Libs
import React from 'react'

// Constants
import { HEFTY_MENU } from '../constants'

// Components
import { Link } from 'react-router-dom'
import Menu from 'fc-icons/src/Menu'
import MobileMenu from './MobileMenu'

import _includes from 'lodash/includes'

// Styles
import { grey, white, notAsDarkGrey, tableBG, primary } from 'hfty-styles/src/colors'

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    textTransform: 'uppercase',
    fontSize: '0.8rem',
    fontWeight: 500,
    boxShadow: `0 0 4px rgba(0,0,0,0.2)`,
    position: `relative`,
    zIndex: 2,
    backgroundColor: white(),
  },
  link: {
    textDecoration: 'none',
    margin: '0 10px',
    padding: '5px',
    cursor: 'pointer',
    color: notAsDarkGrey(),
    height: '30px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
  },
  highlightedLink: {
    textDecoration: 'none',
    margin: '0 10px',
    padding: '5px',
    cursor: 'pointer',
  },
  highlightedDesktopLink: {
    textDecoration: 'none',
    margin: '0 10px',
    padding: '5px',
    cursor: 'pointer',
    height: '30px',
    color: notAsDarkGrey(),
    borderBottom: `3px solid ${primary()}`,
    backgroundColor: tableBG(),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    flex: 1,
  },
  mobileContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: primary(),
    height: '30px',
    alignItems: 'center',
    color: white(),
    flexShrink: 0,
  },
  drawerContainer: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    width: 250,
    backgroundColor: grey(),
    boxShadow: '-1px 0px 1px rgba(0,0,0,0.2)',
    zIndex: 1005,
  },
  onlinkContainer: {
    padding: 15,
    backgroundColor: white(),
  },
  offlinkContainer: {
    padding: 15,
  },
  agphd: {
    fontSize: '0.7rem',
    fontWeight: 500,
    padding: 5,
  },
  selectors: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  usernameContainer: {
    color: notAsDarkGrey(),
    padding: 5,
    margin: '0 10px',
  },
  userInfoContainer: {
    padding: '10px 15px',
  },
}

// Local
function AgPhd(): React.Element<any> {
  return <div style={styles.agphd}>AgPhD</div>
}

// Types
type Props = {
  mobile: boolean,
  toggled: boolean,
  activeRoute: string,
  onToggle: Function,
  push: Function,
  logout: Function,
  username: string,
}

export default function MenuLayout(props: Props): React.Element<any> {
  const { mobile, toggled = false, onToggle, push, logout, username } = props

  let { activeRoute } = props

  if (_includes(activeRoute, 'map')) {
    activeRoute = '/map'
  }

  if (mobile) {
    return (
      <div style={styles.mobileContainer}>
        <AgPhd />
        <div onClick={onToggle}>
          <Menu color={'white'} size={20} />
        </div>
        {toggled ? (
          <MobileMenu onToggle={onToggle} activeRoute={activeRoute} push={push} logout={logout} username={username} />
        ) : null}
      </div>
    )
  }

  return (
    <div style={styles.container}>
      {HEFTY_MENU.map((infoObj: Object): React.Element<any> => {
        const linkStyle = infoObj.url === activeRoute ? styles.highlightedDesktopLink : styles.link
        return (
          <Link style={linkStyle} key={infoObj.label} to={infoObj.url}>
            {infoObj.label}
          </Link>
        )
      })}
    </div>
  )
}
